import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { formatNumbers } from 'helpers/formatNumbers';
import { getHelpText } from 'helpers/glossary';
import { glossary } from 'constants/glossary';
import ContentTile from 'components/atoms/layout/ContentTile';
import CallOutWrapper from 'components/atoms/callout/CallOutWrapper';
import Title from 'components/atoms/callout/Title';
import Value from 'components/atoms/callout/Value';


import {
    HelpBox,
    HelpClose,
    HelpBody,
    HelpTitle,
    HelpIcon,
} from 'components/atoms/callout/Help';

const CallOutSimple = (props) => {
    const [toggleHelp, setToggleHelp] = useState(false);
    const { data, format, title, helpKey, type } = props;
    const glossaryKey = helpKey || type;
    const helpText = glossaryKey && getHelpText({ glossaryKey, glossary });
    const value = formatNumbers(data.value, format);

    const clickToggleHelp = () => setToggleHelp(!toggleHelp);
    return (
        <ContentTile {...props}>
            <CallOutWrapper>
                <Value>{value}</Value>
                <Title>{title}</Title>
                <HelpIcon className="icon-help-circle" onClick={clickToggleHelp} />
                <HelpBox
                    onClick={clickToggleHelp}
                    className={toggleHelp ? 'show-help' : 'hide-help'} >
                    <HelpTitle>{title}</HelpTitle>
                    <HelpBody>{helpText}</HelpBody>
                    <HelpClose className="icon-close-circle" />
                </HelpBox>
            </CallOutWrapper>
        </ContentTile>
    );
};

CallOutSimple.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        value: PropTypes.number.isRequired
    }),
    format: PropTypes.string
};

export default CallOutSimple;



// WEBPACK FOOTER //
// ./src/components/molecules/CallOutSimple.js